// extracted by mini-css-extract-plugin
export default {"box":"future_bEPr38MeO4Mf","center":"future_sZS2Xw95tNIQ"};